(() => {
    console.log('%c👍🏼 Our Work', 'color: yellow');
    const section = document.querySelector('.our-work');
    const filterSection = section.querySelector('.our-work__filters');
    const filterButtons = filterSection.querySelectorAll('button');
    const filterActiveClasses = filterSection.getAttribute('data-active-class').split(' ');
    const filterLoadingClasses = filterSection.getAttribute('data-loading-class').split(' ');
    const resultTemplate = section.querySelector('[data-template-type="result"]');
    const resultStatTemplate = section.querySelector('[data-template-type="result-stat"]');
    const resultCategoryTemplate = section.querySelector('[data-template-type="result-category"]');
    const apiUrl = section.getAttribute('data-api-url');
    const resultsContainer = section.querySelector('.our-work__results');
    const loader = section.querySelector('.our-work__loader');

    const addEventListeners = () => {
        filterButtons.forEach((button) => {
            button.addEventListener('click', async () => {
                filterButtons.forEach((button) => {
                    button.classList.remove(filterActiveClasses);
                });

                button.classList.add(filterLoadingClasses);
                loader.classList.remove('hidden');
                await loadData(button);
            });
        });
    }

    const loadData = async (button) => {
        const fetchUrl = button.dataset.category === 'all' ? (apiUrl + '?all=1') : apiUrl + `?case-studies-tags[]=${button.dataset.category}`;
        const response = await fetch(fetchUrl);
        loader.classList.add('hidden');
        button.classList.remove(filterLoadingClasses);
        button.classList.add(filterActiveClasses);

        if (!response.ok) {
            console.error('Failed to fetch data');
            return;
        }

        const data = await response.json();

        resultsContainer.innerHTML = '';

        data.results.forEach((item) => {
            const clone = resultTemplate.content.cloneNode(true);
            const image = clone.querySelector('img');
            const title = clone.querySelector('.our-work__result-title');
            const links = clone.querySelectorAll('a');

            image.width = item.case_study.image.width;
            image.height = item.case_study.image.height;
            image.src = item.case_study.image.src;
            image.srcset = item.case_study.image.srcset || '';
            image.alt = item.case_study.alt || '';
            title.textContent = item.case_study.title;

            links.forEach((link) => {
                link.href = item.case_study.link;
            });

            if (item.case_study.eventTags && item.case_study.eventTags.length > 0) {
                item.case_study.eventTags.forEach((tag) => {
                    const categoryClone = resultCategoryTemplate.content.cloneNode(true);
                    categoryClone.querySelector('span').textContent = tag.name;
                    clone.querySelector('.our-work__result-categories').appendChild(categoryClone);
                });
            }

            const statsContainer = clone.querySelector('.our-work__result-stats');
            if (!item.case_study.stats || item.case_study.stats.length === 0) {
                statsContainer.remove();
            }

            if(item.case_study.stats && item.case_study.stats.length > 0) {
                item.case_study.stats.forEach((stat) => {
                    const statClone = resultStatTemplate.content.cloneNode(true);
                    const statDesc = statClone.querySelector('.our-work__result-stat-desc');
                    const statValue = statClone.querySelector('.our-work__result-stat-value');

                    statDesc.textContent = stat.stat.blurb;
                    statValue.textContent = stat.stat.before + stat.stat.number + stat.stat.after;
                    statsContainer.appendChild(statClone);
                });
            }

            resultsContainer.appendChild(clone);
        });

        setTimeout(() => {
            requestAnimationFrame(() => {
                resultsContainer.querySelectorAll('.our-work__result').forEach((result, index) => {
                    result.style.animationDelay = `${(index + 1) * 100}ms`;
                    result.classList.remove('opacity-0');
                });
            });
        }, 10);
    }

    addEventListeners();
})();